import React from 'react';
import styled from 'styled-components';

const IconSearch = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconClose = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const IconSort = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="15" y2="12" />
    <line x1="3" y1="18" x2="9" y2="18" />
  </svg>
);

const IconBuilding = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 22V12h6v10" />
    <path d="M9 7h.01M12 7h.01M15 7h.01" />
  </svg>
);

const IconChevron = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const Panel = styled.div`
  background: rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  padding: 14px 16px;
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchWrapper = styled.div`
  flex: 1;
  min-width: 240px;
  position: relative;
  display: flex;
  align-items: center;
`;

const SearchIcon = styled.span`
  position: absolute;
  left: 13px;
  color: rgba(255, 255, 255, 0.35);
  pointer-events: none;
  display: flex;
  align-items: center;
`;

const ClearButton = styled.button`
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  padding: 2px;
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items: center;

  &:hover {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 34px 10px 38px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  font-size: 0.9em;
  color: white;
  box-sizing: border-box;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.32);
  }

  &:focus {
    outline: none;
    border-color: rgba(102, 126, 234, 0.65);
    background: rgba(255, 255, 255, 0.11);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.14);
  }
`;

const ControlsRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ControlGroup = styled.div`
  display: flex;
  align-items: stretch;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: rgba(102, 126, 234, 0.65);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.14);
  }

  @media (max-width: 768px) {
    flex: 1;
  }
`;

const ControlPrefix = styled.span`
  padding: 0 10px;
  font-size: 0.72em;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.38);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
  user-select: none;
`;

const SelectWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const FilterSelect = styled.select`
  appearance: none;
  -webkit-appearance: none;
  padding: 10px 28px 10px 11px;
  background: transparent;
  border: none;
  font-size: 0.88em;
  color: white;
  cursor: pointer;
  min-width: 120px;

  option {
    background: #1e2a3a;
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

const Chevron = styled.span`
  position: absolute;
  right: 9px;
  color: rgba(255, 255, 255, 0.38);
  pointer-events: none;
  display: flex;
  align-items: center;
`;

const ClearFiltersButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.35);
  border-radius: 10px;
  color: #fca5a5;
  font-size: 0.82em;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s ease;

  &:hover {
    background: rgba(239, 68, 68, 0.25);
    border-color: rgba(239, 68, 68, 0.55);
    color: #fecaca;
  }
`;

const DEFAULT_SORT_OPTIONS = [
  { value: 'signatures', label: 'Most Signatures' },
  { value: 'date-new',   label: 'Newest First' },
  { value: 'date-old',   label: 'Oldest First' },
  { value: 'department', label: 'Department' },
  { value: 'title',      label: 'Title A–Z' },
];

const PetitionFilters = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
  departmentFilter,
  onDepartmentChange,
  departments,
  sortOptions = DEFAULT_SORT_OPTIONS,
  defaultSort,
  onClearFilters,
}) => {
  const defaultSortValue = defaultSort || sortOptions[0]?.value;
  const isFiltered = searchTerm !== '' || sortBy !== defaultSortValue || departmentFilter !== 'all';

  return (
    <Panel>
      <SearchWrapper>
        <SearchIcon><IconSearch /></SearchIcon>
        <SearchInput
          type="text"
          placeholder="Search by title, creator, department or ID..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <ClearButton
          visible={searchTerm.length > 0}
          onClick={() => onSearchChange('')}
          aria-label="Clear search"
        >
          <IconClose />
        </ClearButton>
      </SearchWrapper>

      <ControlsRow>
        <ControlGroup>
          <ControlPrefix><IconSort /> Sort</ControlPrefix>
          <SelectWrap>
            <FilterSelect value={sortBy} onChange={(e) => onSortChange(e.target.value)}>
              {sortOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </FilterSelect>
            <Chevron><IconChevron /></Chevron>
          </SelectWrap>
        </ControlGroup>

        <ControlGroup>
          <ControlPrefix><IconBuilding /> Dept</ControlPrefix>
          <SelectWrap>
            <FilterSelect value={departmentFilter} onChange={(e) => onDepartmentChange(e.target.value)}>
              <option value="all">All Departments</option>
              {departments.map(dept => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </FilterSelect>
            <Chevron><IconChevron /></Chevron>
          </SelectWrap>
        </ControlGroup>

        {isFiltered && onClearFilters && (
          <ClearFiltersButton onClick={onClearFilters} aria-label="Clear all filters">
            <IconClose /> Clear filters
          </ClearFiltersButton>
        )}
      </ControlsRow>
    </Panel>
  );
};

export default PetitionFilters;
